
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"22","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M11.25 2.142a.5.5 0 00.451.497 7.094 7.094 0 016.391 7.06v2.63c0 3.494 1.418 5.052 2.289 5.684.465.338.869.88.869 1.514 0 .813-.66 1.473-1.473 1.473H14.19a.5.5 0 00-.49.405 2.73 2.73 0 01-.44 1.052c-.416.59-1.13 1.043-2.26 1.043s-1.844-.453-2.26-1.043a2.73 2.73 0 01-.44-1.052.5.5 0 00-.49-.405H2.223C1.41 21 .75 20.34.75 19.527c0-.635.404-1.176.87-1.514l-.284-.39.283.39c.87-.632 2.289-2.19 2.289-5.684V9.698a7.094 7.094 0 016.39-7.059.5.5 0 00.452-.497V.75a.25.25 0 11.5 0v1.392zM9.361 21a.5.5 0 00-.47.67c.06.167.144.338.257.498.318.45.876.832 1.852.832.976 0 1.534-.381 1.852-.832a2.11 2.11 0 00.257-.498.5.5 0 00-.47-.67H9.36z"}})])
          )
        }
      }
    